<template>
	<div v-loading="loading" class="main-content">
		<div v-if="!loading" class="main-content-inner">
			<div class="container-fluid">
				<div class="row">
					<div class="col-lg-12">
						<div class="content margin-bottom-30">
							<div class="content-header">
								<h2>
									Users ({{ total }})
								</h2>
								<el-button @click="handleAdd()" type="primary" plain size="medium">
									Add user
								</el-button>
							</div>
							<div class="content-body">
								<el-table :data="tableData" :default-sort="{ prop: 'role', order: 'ascending' }" style="width: 100%">
									<el-table-column label="Role" prop="role" sortable width="150">
										<template slot-scope="scope">
											<span style="text-transform: uppercase">{{ getRole(scope.row.role) }}</span>
										</template>
									</el-table-column>
									<el-table-column label="Name" prop="first_name">
										<template slot-scope="scope">
											{{ scope.row.first_name }} {{ scope.row.last_name }}
										</template>
									</el-table-column>
									<el-table-column label="Email" prop="email"></el-table-column>
									<el-table-column align="right" width="250">
										<template slot-scope="scope">
											<el-button @click="handleEdit(scope.row.id)" size="mini" type="primary" plain circle icon="el-icon-edit"></el-button>
											<el-button size="mini" type="danger" plain circle icon="el-icon-delete" :loading="deleting && scope.row.id === currentDelete" @click="handleDelete(scope.row.id)" :disabled="scope.row.id === user.id"></el-button>
										</template>
									</el-table-column>
								</el-table>
								<div v-if="total > pageSize" style="margin-top: 20px; text-align: right;">
									<el-pagination
										:total="total"
										:current-page.sync="currentPage" 
										@current-change="handlePageChange"
										@prev-click="loadData(prevPage)"
										@next-click="loadData(nextPage)"
										layout="prev, pager, next"
										background
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { HTTP } from '@/services/api'
import { mapState } from 'vuex'

export default {
	name: 'Users',
	metaInfo () {
		return {
			title: 'Users',
		}
	},
	data () {
        return {
			loading: true,
			tableData: [],
			total: null,
			pageSize: null,
			prevPage: null,
			nextPage: null,
			currentPage: null,
			deleting: false,
			currentDelete: null,
			roles: [],
        }
    },
	computed: {
        ...mapState(['user'])
	},
	mounted () {
		if (parseInt(this.user.role) !== 1) {
			this.$router.push('/analytics')
		} else {
			this.loadRoles()
		}
	},
	methods: {
		loadRoles () {
			return HTTP({
				method: 'GET',
				url: '/roles',
				crossdomain: true
			})
			.then(response => {
				this.roles = response.data
				this.loadData()
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		loadData () {
			this.loading = true
			HTTP({
				method: 'GET',
				url: '/users',
				crossdomain: true
			})
			.then(response => {
				this.tableData = response.data.data
				this.total = response.data.total
				this.pageSize = response.data.per_page
				this.prevPage = response.data.prev_page_url
				this.nextPage = response.data.next_page_url
				this.currentPage = response.data.current_page
				this.loading = false
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.message,
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		handleEdit (id) {
			this.$router.push('/users/edit/' + id)
		},
		handleDelete (id) {
			this.$confirm('This action will permanently delete user and all data related to the user.', 'Are you sure?', {
				confirmButtonText: 'Delete',
				cancelButtonText: 'Cancel',
				type: 'warning'
			})
			.then(() => {
				this.currentDelete = id
				this.deleteItem(id)
			})
			.catch(() => {
				this.currentDelete = null
			})
		},
		handleAdd () {
			this.$router.push('/users/add')
		},
		deleteItem (id) {
			this.deleting = true
			return HTTP({
				method: 'DELETE',
				url: '/users/' + id,
				crossdomain: true
			})
			.then(() => {
				this.tableData.splice(this.tableData.findIndex(function(i) {
					return i.id === id
				}), 1)
				this.deleting = false
				this.$forceUpdate()
				this.$notify({
					title: 'Success',
					message: 'User has been deleted from database',
					type: 'success',
					position: 'bottom-right',
					duration: 2500
				})
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		getRole (id) {
			if (id) {
				let item = this.roles.find(item => item.id === id)
				return item.name
			}
		},
		handlePageChange (page) {
			this.loadData('/users?page=' + page)
		},
	}
}
</script>
